import React, { useState } from 'react';

const Flip = ({image,name,description}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className="flip-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`flip-card-inner ${isHovered ? 'flipped' : ''}`}>
        <div className="flip-card-front">
          <img src={image} alt={name} className="flip-card-image" />
        </div>
        <div className="flip-card-back">
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Flip;
